var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDeleteBinLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 5.00008H18.3332V6.66675H16.6665V17.5001C16.6665 17.9603 16.2934 18.3334 15.8332 18.3334H4.1665C3.70627 18.3334 3.33317 17.9603 3.33317 17.5001V6.66675H1.6665V5.00008H5.83317V2.50008C5.83317 2.03985 6.20627 1.66675 6.6665 1.66675H13.3332C13.7934 1.66675 14.1665 2.03985 14.1665 2.50008V5.00008ZM14.9998 6.66675H4.99984V16.6667H14.9998V6.66675ZM7.49984 9.16675H9.1665V14.1667H7.49984V9.16675ZM10.8332 9.16675H12.4998V14.1667H10.8332V9.16675ZM7.49984 3.33341V5.00008H12.4998V3.33341H7.49984Z",
    fill: "#D92D20"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteBinLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-bin-line.23dd83a1.svg";
export { ForwardRef as ReactComponent };